import {
  FETCH_SUBJECTS_REQUEST,
  FETCH_SUBJECTS_SUCCESS,
  FETCH_SUBJECTS_FAILURE,
  SAVE_SUBJECT_REQUEST,
  SAVE_SUBJECT_SUCCESS,
  SAVE_SUBJECT_FAILURE,
  DELETE_SUBJECT_REQUEST,
  DELETE_SUBJECT_SUCCESS,
  DELETE_SUBJECT_FAILURE,
} from './types';

const INITIAL_STATE = {
  subjectList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SUBJECTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_SUBJECTS_SUCCESS:
      return {
        ...state,
        loading: false,
        subjectList: action.payload,
      };

    case FETCH_SUBJECTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        subjectList: [],
      };
    case SAVE_SUBJECT_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_SUBJECT_SUCCESS:
      return {
        ...state,
      };

    case SAVE_SUBJECT_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_SUBJECT_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_SUBJECT_SUCCESS:
      return {
        ...state,
      };

    case DELETE_SUBJECT_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
